import React, { Component } from 'react';
import history from '../routes/history';
import Cookies from 'universal-cookie';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem } from 'reactstrap';

export default class Header extends Component {
  
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  signOut = (e) => {
    var cookies = new Cookies();
    cookies.set('AuthenticationToken', null, { path: "/" });
    history.push('/');
  }
  
  render() {
    return (
      <Navbar color="dark" dark expand="md">
        <NavbarBrand href="/">MeSeems Performance Monitor</NavbarBrand>
        <NavbarToggler onClick={this.toggle} />
        <Collapse isOpen={this.state.isOpen} navbar>
          <Nav className="ml-auto" navbar>
            <NavItem>
              <NavLink href="/Analytics/Metrics">Metrics</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="/Analytics/Alerts">Alerts</NavLink>
            </NavItem>
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret>
              Account
              </DropdownToggle>
              <DropdownMenu >
                <DropdownItem onClick={this.signOut}>
                  Sign Out
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </Collapse>
      </Navbar>
    );
  }

}


// WEBPACK FOOTER //
// ./src/components/Header.js